import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getTransactions = async ({
  paymentMethod,
  transactionType,
  status,
  currencyId,
  pageNumber,
}) => {
  // Provide safe fallbacks
  const safePaymentMethod = paymentMethod || 'deposit';
  const safeStatus = status || 'all';
  const safeCurrencyId = currencyId || 'default'; // Replace with actual default or fallback
  const safePageNumber = pageNumber || 1;

  let useTransactionType = transactionType;
  if (transactionType === 'mobilemoney') useTransactionType = 'mm';
  if (transactionType === 'manualBank') useTransactionType = 'manualBank';

  let endpoint;

  if (safeStatus === 'all') {
    endpoint = `/transaction/${safePaymentMethod}/${safeCurrencyId}/${safePageNumber}`;
  } else if (safePaymentMethod === 'transfer' || safePaymentMethod === 'swap') {
    endpoint = `/transaction/${safePaymentMethod}/${safeStatus}/${safeCurrencyId}/${safePageNumber}`;
  } else {
    const finalTransactionType = useTransactionType || 'merchantPay'; // sensible default
    endpoint = `/transaction/${finalTransactionType}/${safePaymentMethod}/${safeStatus}/${safeCurrencyId}/${safePageNumber}`;
  }

  console.log('[getTransactions] Final endpoint:', endpoint);

  return axios.get(endpoint);
};

export const useTransactions = ({
  paymentMethod,
  transactionType,
  status,
  currencyId,
  pageNumber = 1,
  config,
}) => {
  return useQuery({
    ...config,
    queryKey: [
      'transactions',
      paymentMethod || 'deposit',
      transactionType || 'merchantPay',
      status || 'all',
      currencyId || 'default',
      pageNumber,
    ],
    queryFn: () =>
      getTransactions({
        paymentMethod,
        transactionType,
        status,
        currencyId,
        pageNumber,
      }),
  });
};



// import { axios } from 'lib/axios';
// import { useQuery } from 'react-query';

// export const getTransactions = async ({
//   paymentMethod,
//   transactionType,
//   status,
//   currencyId,
//   pageNumber,
// }) => {
//   // Normalize values
//   const safePaymentMethod = paymentMethod || 'deposit';
//   const safeStatus = status || 'all';
//   const safeCurrencyId = currencyId || 'NGN'; // fallback currency
//   const safePageNumber = pageNumber || 1;

//   let useTransactionType = transactionType;
//   if (transactionType === 'mobilemoney') useTransactionType = 'mm';
//   if (transactionType === 'manualBank') useTransactionType = 'manualBank';

//   let endpoint;

//   if (safePaymentMethod === 'transfer' || safePaymentMethod === 'swap') {
//     // These don't use transactionType
//     endpoint = `/transaction/${safePaymentMethod}/${safeStatus}/${safeCurrencyId}/${safePageNumber}`;
//   } else {
//     const finalTransactionType = useTransactionType || 'mm'; // default type if needed
//     endpoint =
//       safeStatus === 'all'
//         ? `/transaction/${finalTransactionType}/${safePaymentMethod}/${safeCurrencyId}/${safePageNumber}`
//         : `/transaction/${finalTransactionType}/${safePaymentMethod}/${safeStatus}/${safeCurrencyId}/${safePageNumber}`;
//   }

//   console.log('[getTransactions] Final endpoint:', endpoint);
//   return axios.get(endpoint);
// };

// export const useTransactions = ({
//   paymentMethod,
//   transactionType,
//   status,
//   currencyId,
//   pageNumber = 1,
//   config,
// }) => {
//   return useQuery({
//     ...config,
//     queryKey: [
//       'transactions',
//       paymentMethod || 'deposit',
//       transactionType || 'mm',
//       status || 'all',
//       currencyId || 'NGN',
//       pageNumber,
//     ],
//     queryFn: () =>
//       getTransactions({
//         paymentMethod,
//         transactionType,
//         status,
//         currencyId,
//         pageNumber,
//       }),
//   });
// };
